module.exports = __webpack_public_path__ + "img/Peanut Icon - charcoal.8b70abdf.svg";